import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import LocationMap from "../../components/map/LocationMap.vue";
import providerApiService from "../../services/api/ProviderApiService";
export default {
  name: "ProviderAddress",
  components: {
    LocationMap: LocationMap
  },
  data: function data() {
    return {
      locationPinned: this.isUpdate,
      coordinates: this.address.coordinates,
      location: this.address.location
    };
  },
  methods: {
    toggleLocationPinned: function toggleLocationPinned() {
      this.locationPinned = !this.locationPinned;
    },
    selectLocation: function selectLocation(coordinates) {
      this.locationPinned = true;
      this.coordinates = coordinates;
    },
    submitAddress: function submitAddress() {
      var _this = this;

      if (!this.location) {
        this.$vs.notify({
          text: "وارد کردن جزئیات آدرس اجباریست.",
          color: "warning",
          position: "bottom-center"
        });
        return;
      }

      this.$vs.loading();
      providerApiService.submitOrUpdateAddress(this.currentProvider.id, this.coordinates[0], this.coordinates[1], this.location, this.address.id, this.isUpdate).then(function (result) {
        _this.$emit("locationAdded", result.resource);
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    },
    removeAddress: function removeAddress() {
      var _this2 = this;

      this.$vs.loading();
      providerApiService.deleteAddress(this.currentProvider.id, this.address.id).then(function () {
        return _this2.$emit("locationRemoved");
      }).finally(function () {
        return _this2.$vs.loading.close();
      });
    }
  },
  props: {
    isUpdate: {
      required: true,
      type: Boolean
    },
    address: {
      required: true,
      type: Object
    }
  },
  mounted: function mounted() {},
  computed: mapGetters({
    currentProvider: "profile/currentProvider"
  })
};